import { render } from "./VideoElementProduction.vue.js?vue&type=template&id=12b9d43b!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoElementProduction.vue?vue&type=template&id=12b9d43b"
import script from "./VideoElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoElementProduction.vue?vue&type=script&lang=js"
export * from "./VideoElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoElementProduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/video-element/VideoElementProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12b9d43b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12b9d43b', __exports__)) {
    api.reload('12b9d43b', __exports__)
  }
  
  module.hot.accept("./VideoElementProduction.vue.js?vue&type=template&id=12b9d43b!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoElementProduction.vue?vue&type=template&id=12b9d43b", () => {
    api.rerender('12b9d43b', render)
  })

}


export default __exports__